<template>
    <div class="d-dropdown-spacer" />
</template>

<script>
export default {
    name: 'DDropdownSpacer'
}
</script>

<style lang="scss" scoped>
.d-dropdown-spacer {
    background: rgba(0,0,0,0.14);
    height: 1px;
    width: 100%;
}

.d-dropdown-spacer + .d-dropdown-spacer {
    /* Hide subsequent spacers if there are no items in between */
    display: none;
}
</style>
